import { api as generatedApi } from './operations.generated';

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: ['CustomBranding', 'ClinicSetup', 'CustomVirtualBackgrounds'],
  endpoints: {
    getCustomBranding: {
      providesTags: ['CustomBranding'],
    },
    getCustomBrandingBySlug: {
      providesTags: (_result, _error, arg) => [
        { type: 'CustomBranding' as const, id: arg.input.slug },
      ],
    },
    getCustomVirtualBackgrounds: {
      providesTags: ['CustomVirtualBackgrounds'],
    },
    upsertCustomBranding: {
      invalidatesTags: [
        'CustomBranding',
        'ClinicSetup',
        'CustomVirtualBackgrounds',
      ],
    },
  },
});

export const {
  useUpsertCustomBrandingMutation,
  useGetCustomBrandingQuery,
  useLazyGetCustomBrandingQuery,
  useGetCustomBrandingBySlugQuery,
  useLazyGetCustomBrandingBySlugQuery,
  useGetCustomVirtualBackgroundsQuery,
} = api;
